import {gql} from "@apollo/client";

export const GET_APPOINTMENT_BY_UUID = gql`
  query ($uuid: String!) {
    getAppointmentByUUID(uuid: $uuid) {
      data {
        id
        refId
        uuid
        status
        customerEmail
        bookingStart
        bookingEnd
      }
      errors {
        message
      }
    }
  }
`;

export const GET_APPOINTMENT_BY_REFID = gql`
  query ($refId: Float!) {
    getAppointmentByRefId(refId: $refId) {
      data {
        id
        refId
        uuid
        status
        customerEmail
        bookingStart
        bookingEnd
        otherData
      }
      errors {
        message
      }
    }
  }
`;
